
import { create } from "zustand";
import { Logger } from "@/lib/app-log.js";

export const useSystemSurveysStore = create((set) => ({
  // Data
  surveys: [],
  loading: false,
  error: null,
  success: null,

  // Pagination
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Search & Filter — page/pageSize live here so list refetch effects can depend on them
  searchParams: {
    page: 1,
    pageSize: 10,
    searchTerm: "",
    sortBy: "createdAt",
    sortDirection: "desc",
  },
  columnFilters: {},
  uniqueValues: {},

  // UI State
  isSurveyBuilderOpen: false,
  currentSurvey: null,


  // Actions - Data
  setSurveys: (surveys) => set({ surveys }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  // Actions - Search & Filter
  setSearchParams: (params) =>
    set((state) => ({
      searchParams: { ...state.searchParams, ...params },
    })),

  setSearchTerm: (searchTerm) =>
    set((state) => ({
      searchParams: { ...state.searchParams, searchTerm, page: 1 },
    })),

  setSorting: (sortBy, sortDirection) =>
    set((state) => ({
      searchParams: { ...state.searchParams, sortBy, sortDirection, page: 1 },
    })),

  setColumnFilters: (filters) =>
    set((state) => ({
      columnFilters: filters,
      searchParams: { ...state.searchParams, page: 1 },
    })),

  setCurrentPage: (page) =>
    set((state) => ({
      searchParams: { ...state.searchParams, page },
    })),

  setPageSize: (pageSize) =>
    set((state) => ({
      searchParams: { ...state.searchParams, pageSize, page: 1 },
    })),

  // Actions - UI
  openSurveyBuilder: (survey = null) =>
    set({ isSurveyBuilderOpen: true, currentSurvey: survey, error: null }),

  closeSurveyBuilder: () =>
    set({ isSurveyBuilderOpen: false, currentSurvey: null, error: null }),



  clearError: () => set({ error: null }),
  clearSuccess: () => set({ success: null }),
  clearMessages: () => set({ error: null, success: null }),

  // Deprecated actions (kept for API compatibility during migration but should not be used directly)
  fetchSurveys: () => Logger.warn("Use formTemplateIntegration.fetchSurveys instead"),
  deleteSurvey: () => Logger.warn("Use formTemplateIntegration.deleteSurvey instead"),
  saveSurvey: () => Logger.warn("Use formTemplateIntegration.createSurvey/updateSurvey instead"),
}));

export default useSystemSurveysStore;
